<template>
  <div class="col-12 form-single-1">

    <form @submit.prevent="submitForm">
      <div v-for="(input,index) in prepareInputsConfig" :class="itemClass">


        <radio-box1 :form-answer="formAnswer" :inputConfig="input" v-if="input.type == 'radiobox'"
                    :key="index"/>

        <text-area1 :form-answer="formAnswer" :inputConfig="input" v-if="input.type == 'textarea'"
                    :key="index"/>

        <image-input1 :form-answer="formAnswer" :inputConfig="input" v-if="input.type == 'image'"
                      :key="index"/>

        <select-box-input1 :form-answer="formAnswer" :inputConfig="input" v-if="input.type == 'selectbox'"
                           :key="index"/>

        <range-input1 :form-answer="formAnswer" :inputConfig="input" v-if="input.type == 'range'"
                      :key="index"/>

        <select-box-with-filter-input1 :form-answer="formAnswer" :inputConfig="input"
                                       v-if="input.type == 'select-box-with-filter'"
                                       :key="index"/>

        <text-input1 :form-answer="formAnswer" :inputConfig="input" v-if="input.type == 'text'"
                     :key="index"/>

      </div>

      <div class="col-12 form-single-1-button-parent text-center">
        <button ref="form_submit_button" class="btn px-5 btn-primary form-single-1-button"><span v-t="`form.form_single.form_button_submit`" ></span></button>
      </div>

    </form>
  </div>
</template>

<script>
import {defineComponent} from 'vue'
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import RadioBox1 from "../components/RadioBox/RadioBox1.vue";
import TextArea1 from "../components/TextArea/TextArea1.vue";
import ImageInput1 from "../components/ImageInput/ImageInput1.vue";
import SelectBoxInput1 from "../components/SelectBoxInput/SelectBoxInput1.vue";
import RangeInput1 from "../components/Range/RangeInput1.vue";
import TextInput1 from "../components/TextInput/TextInput1.vue";
import SelectBoxWithFilterInput1 from "../components/SelectBoxWithFilterInput/SelectBoxWithFilterInput1.vue";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";


export default defineComponent({
  name: "FormSingle1",
  components: {RadioBox1, TextArea1, ImageInput1, SelectBoxInput1, RangeInput1, SelectBoxWithFilterInput1, TextInput1},
  props: {
    itemClass: {
      default: 'col-lg-12 mb-3'
    },
    formId: {
      default: null
    },
    redirectToDashboard: {
      default: false,
      type: Boolean
    },
    redirectDirectLink: {
      default: ''
    },
  },
  data() {
    return {
      form: {},
      formQuestions: '',
      formAnswer: {},
      dataForm: {
        form_id: 1
      }
    }
  },
  computed: {
    prepareInputsConfig() {
      if (this.formQuestions.length === 0) {
        return []
      }
      let questions = JSON.parse(this.formQuestions)
      questions = questions.filter(item => {
        return item.visibility == undefined || item.visibility == true
      })

      return questions
    }
  },
  methods: {
    compileDescription(description) {
      try {
        return JSON.parse(description)
      } catch (e) {
        return {}
      }
    },
    submitForm() {

      let form = {
        form_id: this.dataForm.form_id,
        answer: this.formAnswer
      }

      let req = this.$store.dispatch('Form/storeFormAnswer', form)

      this.$refs.form_submit_button.disabled = true

      req.then(res => {
        toast('ثبت اطلاعات با موفقیت انجام شد', 'ثبت اطلاعات با موفقیت انجام شد')

        if (this.redirectToDashboard) {
          let link = findAttributeOnSiteInfo('dashboard_link')[0] + '/' + 'user/form-fills'
          window.open(link)
          return true
        }

        if (this.redirectDirectLink.length > 0) {
          window.location = this.redirectDirectLink
          return true
        }

        this.$refs.form_submit_button.disabled = false

      }).catch((err) => {
        this.$refs.form_submit_button.disabled = false
      })

    },
    async loadForm() {
      let req = await this.$store.dispatch('Form/getForm', this.dataForm)
      this.form = req.data.data
      this.formQuestions = this.form.form_questions
    }
  },
  async mounted() {

    if (this.formId != null) {
      this.dataForm.form_id = this.formId
    } else {
      this.dataForm.form_id = this.$route.params.id
    }
    await this.loadForm()

  },
})
</script>

<style scoped>

</style>